import {
    getConfig,
    getRawRemoteConfig,
} from '@superbet-group/web.lib.config';
import {
    Country,
    Locale,
} from '@superbet-group/web.types';

let configuration: SportOfferConfig | undefined;

export function getSportOfferConfig(
    remoteConfig: SportOfferRemoteConfigDto = getRawRemoteConfig() as SportOfferRemoteConfigDto,
): SportOfferConfig {
    if (!configuration) {
        configuration = {
            serviceUrl: remoteConfig.betBuilderServer,
            streamingServiceUrl: remoteConfig.betBuilderStreamingHost,
            statsHost: remoteConfig.statsHost,
            country: getConfig().countrySpecific.country,
            appVariant: getConfig().countrySpecific.sport.v5Config.applicationVariant,
            locale: getConfig().appLocale.locale,
            combinableMarketGroupIds: new Set(parseInts(remoteConfig.combinableMarketGroupIds ?? remoteConfig.combinableMarketGroupId ?? '')),
            betslipRedesignUUIDRange: remoteConfig.betslipRedesignUUIDRange,
            showBetPlacedOverlay: remoteConfig.showBetPlacedOverlay,
            isPrepareLiveTicketsEnabled: !!remoteConfig.isPrepareLiveTicketsEnabled,
        };
    }

    return configuration;
}

type SportOfferRemoteConfigDto = {
    betBuilderServer: string;
    betBuilderStreamingHost: string;
    statsHost: string;
    /**
     * @deprecated Use combinableMarketGroupIds instead, this is scheduled for removal.
     */
    combinableMarketGroupId?: string;
    combinableMarketGroupIds?: string;
    betslipRedesignUUIDRange?: string
    showBetPlacedOverlay?: boolean;
    isPrepareLiveTicketsEnabled?: boolean;
};

type SportOfferConfig = {
    serviceUrl: string;
    streamingServiceUrl: string;
    statsHost: string;
    country: Country;
    appVariant: string;
    locale: Locale;
    combinableMarketGroupIds: Set<number>;
    betslipRedesignUUIDRange?: string;
    showBetPlacedOverlay?: boolean;
    isPrepareLiveTicketsEnabled: boolean;
};

function parseInts(string: string): number[] {
    return string.split(',')
        .map((value) => parseInt(value.trim(), 10))
        .filter((value) => !isNaN(value));
}
